export default __webpack_public_path__ + "static/member-icn2-3093cf5ad4c7e18c500825646c7c90a5.png";